(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.services.nav
   */
  angular
    .module("akitabox.mobile.services.nav", ["ngMaterial"])
    .factory("Navigation", NavigationFactory);

  /**
   * @ngdoc factory
   * @module akitabox.mobile.services.nav
   * @name NavigationFactory
   * @description
   * Service to handle navigation interaction
   */
  /* @ngInject */
  function NavigationFactory($mdSidenav) {
    var service = {
      buildSidenavToggler: buildSidenavToggler,
    };

    return service;

    /**
     * Build a side navigation toggler
     *
     * @param  {String}     navId   Unique side nav ID
     * @return {Function}           Sidenav toggle function
     */
    function buildSidenavToggler(navId) {
      return function () {
        $mdSidenav(navId).toggle();
      };
    }
  }
})();
